import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'
import initMsn2026Registration from './initializers/Msn2026Registration.js'

const initApplication = () => {
  initModal()
  initUser()
  initMsn2026Registration()
}

export default initApplication
